import { render, staticRenderFns } from "./FbRadioButtonOption.vue?vue&type=template&id=65c50141"
import script from "./FbRadioButtonOption.vue?vue&type=script&lang=js"
export * from "./FbRadioButtonOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports